"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderByDescAsc = exports.CampaignOrderBy = exports.CampaignOrderByCached = void 0;
var CampaignOrderByCached;
(function (CampaignOrderByCached) {
    CampaignOrderByCached["TotalEngagement"] = "total_engagement";
    CampaignOrderByCached["Sales"] = "sales";
    CampaignOrderByCached["LastPostTimestamp"] = "last_post_timestamp";
    CampaignOrderByCached["Mentions"] = "mentions";
})(CampaignOrderByCached = exports.CampaignOrderByCached || (exports.CampaignOrderByCached = {}));
var CampaignOrderBy;
(function (CampaignOrderBy) {
    CampaignOrderBy["UpdatedAt"] = "updated";
    CampaignOrderBy["CampaignPosts"] = "campaign_posts";
    CampaignOrderBy["Influence"] = "influence";
    CampaignOrderBy["Fans"] = "fans";
    CampaignOrderBy["TrueReach"] = "true_reach";
    CampaignOrderBy["Campaigns"] = "campaigns";
    CampaignOrderBy["Location"] = "location";
    CampaignOrderBy["Skills"] = "skills";
    CampaignOrderBy["Tags"] = "tags";
    CampaignOrderBy["ContactInfo"] = "contact_info";
    CampaignOrderBy["Budget"] = "budget";
    CampaignOrderBy["CustomVar1"] = "custom_var1";
    CampaignOrderBy["Email"] = "email";
    CampaignOrderBy["Stage"] = "stage";
    CampaignOrderBy["Agreement"] = "agreement";
    CampaignOrderBy["Owner"] = "owner";
    CampaignOrderBy["InviteStatus"] = "invite_status";
    CampaignOrderBy["StoriesConnected"] = "stories_connected";
    CampaignOrderBy["YoutubeConnected"] = "youtube_connected";
    CampaignOrderBy["Notes"] = "notes";
    CampaignOrderBy["Feedback"] = "feedback";
    CampaignOrderBy["TwitterReach"] = "twitter_reach";
    CampaignOrderBy["InstagramReach"] = "instagram_reach";
    CampaignOrderBy["FacebookReach"] = "facebook_reach";
    CampaignOrderBy["YoutubeReach"] = "youtube_reach";
    CampaignOrderBy["TikTokReach"] = "tiktok_reach";
    CampaignOrderBy["InstagramStoriesReach"] = "insta_stories_reach";
    CampaignOrderBy["TwitterFollowers"] = "twitter_followers";
    CampaignOrderBy["InstagramFollowers"] = "instagram_followers";
    CampaignOrderBy["FacebookFans"] = "facebook_fans";
    CampaignOrderBy["YoutubeSubscribers"] = "youtube_subscribers";
    CampaignOrderBy["BlogMonthlyVisitors"] = "blog_monthly_visitors";
    CampaignOrderBy["InstagramEngPerPost"] = "instagram_eng_per_post";
    CampaignOrderBy["InstagramEngRate"] = "instagram_eng_rate";
    CampaignOrderBy["FacebookEngPerPost"] = "facebook_eng_per_post";
    CampaignOrderBy["FacebookEngRate"] = "facebook_eng_rate";
    CampaignOrderBy["YoutubeEngPerPost"] = "youtube_eng_per_post";
    CampaignOrderBy["TwitterAges"] = "twitter_ages";
    CampaignOrderBy["YoutubeEngRate"] = "youtube_eng_rate";
    CampaignOrderBy["InstagramAges"] = "instagram_ages";
    CampaignOrderBy["InstagramBusinessAges"] = "instagram_business_ages";
    CampaignOrderBy["InstagramBusinessCountries"] = "instagram_business_countries";
    CampaignOrderBy["InstagramBusinessMonthlyReach"] = "instagram_business_monthly_reach";
    CampaignOrderBy["TotalEngagement"] = "total_engagement";
    CampaignOrderBy["Sales"] = "sales";
    CampaignOrderBy["LastPostTimestamp"] = "last_post_timestamp";
    CampaignOrderBy["Mentions"] = "mentions";
    CampaignOrderBy["ExpectedPosts"] = "expected_posts";
})(CampaignOrderBy = exports.CampaignOrderBy || (exports.CampaignOrderBy = {}));
var OrderByDescAsc;
(function (OrderByDescAsc) {
    OrderByDescAsc["DESC"] = "DESC";
    OrderByDescAsc["ASC"] = "ASC";
})(OrderByDescAsc = exports.OrderByDescAsc || (exports.OrderByDescAsc = {}));
//# sourceMappingURL=campaignOrderBy.enum.js.map